// extracted by mini-css-extract-plugin
export default {"container":"s07_container__OtwhI"};